import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { FileText } from "lucide-react";
import { FAQCategory } from "./faq/FAQCategory";
import { faqCategories, categoryLabels, faqPageTranslations, getText } from "./faq/faqData";
import { useLanguage } from "@/contexts/LanguageContext";
import { trackedDownloadUrl } from "@/lib/downloadTracking";

export const FAQ = () => {
  const { language } = useLanguage();
  const t = faqPageTranslations;

  return (
    <section id="faq" className="py-16 bg-secondary/30">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-16 animate-fade-up">
          <span className="inline-block px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            {getText(t.sectionLabel, language)}
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-4">
            {getText(t.title, language)}
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-6">
            {getText(t.description, language)}
          </p>
          <Button
            variant="outline"
            className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
            asChild
          >
            <a href={trackedDownloadUrl("broschuere-2025", language)}>
              <FileText className="mr-2 h-5 w-5" />
              {getText(t.brochureButton, language)}
            </a>
          </Button>
        </div>

        <Tabs defaultValue="allgemein" className="w-full">
          <TabsList className="grid w-full grid-cols-2 lg:grid-cols-5 mb-8 h-auto">
            {Object.entries(categoryLabels).map(([key, label]) => (
              <TabsTrigger key={key} value={key} className="text-sm lg:text-base py-3">
                {getText(label, language)}
              </TabsTrigger>
            ))}
          </TabsList>

          {Object.entries(faqCategories).map(([category, faqs]) => (
            <TabsContent key={category} value={category} className="mt-0">
              <FAQCategory category={category} faqs={faqs} />
            </TabsContent>
          ))}
        </Tabs>

        <div className="text-center mt-12">
          <p className="text-muted-foreground mb-4">
            {getText(t.moreQuestions, language)}
          </p>
          <Button
            size="lg"
            className="bg-primary hover:bg-primary-hover text-primary-foreground shadow-glow"
            onClick={() => window.location.href = '#kontakt'}
          >
            {getText(t.contactButton, language)}
          </Button>
        </div>
      </div>
    </section>
  );
};
